// extracted by mini-css-extract-plugin
module.exports = {"button":"_35875ce240--button--Z6Tn1"};